export type PrometheusPostgreSqlSelectReturnedStatsBackendApiProps = {
    created: number;
    instance: string;
    pg_stat_database_tup_returned: number;
};

export default class PrometheusPostgreSqlSelectReturnedStats {
    readonly created: number;
    readonly instance: string;
    readonly pgStatDatabaseTupReturned: number;

    constructor(props: PrometheusPostgreSqlSelectReturnedStatsBackendApiProps) {
        this.created = props.created;
        this.instance = props.instance;
        this.pgStatDatabaseTupReturned = props.pg_stat_database_tup_returned;
    }
}
